import { mobileWatchedThreshold } from "@lib/constants";

// The YouTube-style "how much of this have I watched" bar pinned to the bottom
// edge of a video thumbnail. Shared by the iPhone thumbnail and the funder
// workspace meeting strip so both read the same fraction and hide on the same
// rule. Render it inside a `VideoPoster`'s children (the poster is the
// positioning context).
//
// A never-started video has no bar; anything else shows one. A watched video
// (>= mobileWatchedThreshold) pins the bar completely full rather than showing
// the raw fraction — the playhead usually rests a hair short of the end, and a
// 97% bar on a video the app counts as watched reads as "not quite done".
export function WatchProgressStripe({
  // Fraction watched in [0, 1] (watchedSeconds / durationSeconds).
  watchFraction,
}: {
  watchFraction: number;
}) {
  if (watchFraction <= 0) {
    return null;
  }

  const watched = watchFraction >= mobileWatchedThreshold;
  const percent = watched
    ? 100
    : Math.min(100, Math.max(0, watchFraction * 100));

  return (
    <div className="absolute inset-x-0 bottom-0 h-1.5 bg-black/10">
      <div className="h-full bg-primary" style={{ width: `${percent}%` }} />
    </div>
  );
}
